export const snakeToTitleCase = (str: string) => {
  const splitVal = str.split('_');
  return splitVal.map((val) => val.charAt(0).toUpperCase() + val.slice(1)).join(' ');
};
